/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 * Styled components for Header Selector
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.12.0
 * @since 1.0.0
 */
import styled from 'styled-components';

import { colors, fonts } from '../../../../theme';
import { IAttrStyled } from '../../../../types/globalTypes';

export const AboutLinkStyled = styled.a.attrs({
    tabIndex: -1,
    target: '_blank',
})`
    outline: none;
`;

export const AboutLinkSelfStyled = styled.a.attrs(({ dataName }: { dataName?: string }) => ({
    'tabIndex': -1,
    'data-dropdown-dataname-item': dataName,
}))<{ url?: string }>`
    outline: none;
`;

export const AboutLinkTextStyled = styled.span`
    ${fonts.textLink};
`;

export const HeaderContainerStyled = styled.div.attrs(({ className }: IAttrStyled) => ({
    className: `header-selector ${className}`,
    tabIndex: 0,
}))<IAttrStyled>`
    width: auto;
    height: 64px;
    position: relative;
    outline: none;
    cursor: default;
    padding-right: 2px;

    & .header-selector__block {
        display: flex;
        align-items: center;
        height: 64px;
        padding-left: 16px;
        box-sizing: border-box;
    }

    .header-selector__block .block-with-icon__icon-left {
        padding-right: 8px;
    }

    .header-selector__block .block-with-icon__icon-right {
        transition: transform 300ms linear;
    }

    &.open .header-selector__block .block-with-icon__icon-right {
        transition: transform 200ms linear;
        transform: rotate(180deg);
    }
`;

export const HeaderDropDownMenuStyled = styled.div.attrs({
    className: 'header-selector__dropdown dropdown__menu',
})`
    position: absolute;
    top: 64px;
    right: 0;
    z-index: 10;
    flex-direction: column;
    display: flex;
    width: 275px;
    box-sizing: border-box;
    border-top: 2px solid ${colors.corporateHeaderBorderUnderline};
    box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.2);
    background-color: ${colors.corporateHeaderBgColor};

    & .header-selector__dropdown.dropdown__item {
        padding: 8px 24px;
        box-sizing: border-box;
    }

    & .header-selector__dropdown.dropdown__item:first-child {
        padding-top: 24px;
    }

    & .header-selector__dropdown.dropdown__item:last-child {
        padding-bottom: 24px;
    }

    & a {
        display: block;

        &:hover ${AboutLinkTextStyled},
        &:focus ${AboutLinkTextStyled} {
            border-bottom: 1px solid ${colors.linkDefaultColorHover};
        }
    }
`;

export const HeaderPhoneStyled = styled.div.attrs({
    'className': 'header-selector__phone',
    'data-header-phone': 'headerPhone',
})`
    ${fonts.textMain};
    width: 188px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow-x: hidden;
`;


export const HeaderNameStyled = styled.div.attrs({
    'className': 'header-selector__name',
    'data-header-name': 'position-name',
})`
    ${fonts.textSmall};
    color: ${colors.corporateHeaderTextSecondary};
    width: 188px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;
